<template>
  <v-list :class="{'compact': compact}" class="bg-transparent!" two-line>
    <v-list-item>
      <v-list-item-content v-if="date">
        <v-list-item-title style="font-size: 13px">
          <v-icon small>mdi-calendar-outline</v-icon>
          {{ dateFormat(date) }}
        </v-list-item-title>
        <v-list-item-title style="font-size: 13px" v-if="!onlyDate">
          <v-icon small>mdi-clock-outline</v-icon>
          {{ timeFormat(date) }}
        </v-list-item-title>
      </v-list-item-content>
      <v-list-item-content v-else>
        <v-list-item-title>
          -
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import { dateFormat, timeFormat } from '@/composables/useFilters';

@Component({})
export default class FpDateTimeView extends Vue {
  public dateFormat = dateFormat;
  public timeFormat = timeFormat;

  @Prop({required: true, })
  public readonly date!: Date;

  @Prop({default: false, })
  public readonly onlyDate!: boolean;

  @Prop()
  public readonly compact!: boolean;
}
</script>

<style lang="scss" scoped>
.compact {
  .v-list-item {
    padding: 0;
  }
  .v-list-item__content {
    padding: 0;
  }
}
</style>
